import React from "react";
import usePermission from "hooks/usePermission";

/**
 * PermissionGate Component
 * Wraps elements/components to restrict rendering based on user permissions.
 *
 * Props:
 * - permission / permissions / requires: string | string[]
 * - mode: "any" | "all" (default: "any")
 * - fallback: React.ReactNode (rendered when user does NOT have permission, default: null)
 * - children: React.ReactNode | ((isAllowed: boolean) => React.ReactNode)
 */
const PermissionGate = ({
  permission,
  permissions,
  requires,
  mode = "any",
  fallback = null,
  children,
}) => {
  const targetPermission = permission || permissions || requires;
  const { isAllowed } = usePermission(targetPermission, mode);

  if (typeof children === "function") {
    return children(isAllowed);
  }

  if (isAllowed) {
    return <>{children}</>;
  }

  return fallback ? <>{fallback}</> : null;
};

export default PermissionGate;
